import React from "react";
import { Link } from "@material-ui/core";
import useDriverAppAnnouncement, {
  DOWNLOAD_URL,
} from "./useDriverAppAnnouncement";

const DriverAppNavbarLink = () => {
  const { isVisible } = useDriverAppAnnouncement();

  if (!isVisible) {
    return null;
  }

  return (
    <Link
      className="banner-announcement"
      href={DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span role="img" aria-label="annonce">
        📣
      </span>
      &nbsp;Découvrez la nouvelle app FluidIT Driver !
    </Link>
  );
};

export default DriverAppNavbarLink;
